import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';


@Injectable()
export class APIImportPreferenceService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }


    public importPref(data): Observable<any> {


        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin',"*");
        
        let b = this.http.post(APIConstants.IMPORTPREFERENCE, data, { headers });
        return b;

    }

  //HEader Import
  public importHeader(data): Observable<any> {


    const headers = new HttpHeaders();
    headers.set('content-type', null);
    headers.set('Accept', 'multipart/form-data');
    headers.set('Access-Control-Allow-Origin',"*");

    let b = this.http.post(APIConstants.IMPORTHEADER, data, { headers });
    return b;

   }

    //Template Import
  public importTemplate(data): Observable<any> {


    const headers = new HttpHeaders();
    headers.set('content-type', null);
    headers.set('Accept', 'multipart/form-data');
    headers.set('Access-Control-Allow-Origin',"*");

    let b = this.http.post(APIConstants.IMPORTTEMPLATE, data, { headers });
    return b;

   }

    public importComplaints(data): Observable<any> {

        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');

        let b = this.http.post(APIConstants.IMPORTCOMPLAINTS, data, { headers });
        return b;

    }

    // public getDashboardPreferenceCount(): Observable<any> {
    //     console.log("inside count");
    //     return this.http.get(APIConstants.GETDASHBOARDPREFERENCECOUNT);
    // }

    public getPreferenceSummary(): Observable<any> {
        return this.http.get(APIConstants.PREFERNCESUMMARY);

    }
    public getPreferenceNCPRDetails(BatchId): Observable<any> {
        return this.http.get(APIConstants.PREFERENCENCPRDETAILS + '/' + BatchId);

    }

    public getPreferenceSummaryFilter(data: any): Observable<any> {
        console.log("serive file",data);
        return this.http.post(APIConstants.GETPREFERENCESUMMARYFILTER, data);

    }

    public getPreferenceSummaryDetailsFilter(data: any): Observable<any> {
        console.log("serive file",data);
        return this.http.post(APIConstants.GETPREFERENCESUMMARYDETAILSFILTER, data);

    }
    public downloadFaill(BatchId): Observable<any>{
        console.log("batch id is", BatchId)
        return this.http.get(APIConstants.FAILUREFILEDOWNLOAD+ '/' + BatchId,{responseType: "blob"});
    }
	
	public downloadFail(BatchId): Observable<any>{
        console.log("batch id is", BatchId)
        return this.http.get(APIConstants.DOWNLOADFILEPREFERENCE+ '/' + BatchId,{responseType: "blob"});
    }

    public getPreferenceDownload(date: any): Observable<any> {
        console.log("serve file",date);
        return this.http.get(APIConstants.PREFERENCEDOWNLOAD + '/'+ date,{responseType: "blob"});

    }
    
    public getComplaintsNCPRDetails(BatchId): Observable<any> {
        return this.http.get(APIConstants.COMPLAINTSNCPRDETAILS + '/' + BatchId);

    }
    
}